import { createActionTypes } from "@helpers/redux-helpers";

export const getCreatorProfileActionTypes =
  createActionTypes("creatorProfile/get");

export const blockCreatorActionTypes = createActionTypes(
  "creatorProfile/block",
);

export const unblockCreatorActionTypes = createActionTypes(
  "creatorProfile/unblock",
);

export const followCreatorActionTypes = createActionTypes(
  "creatorProfile/follow",
);

export const unfollowCreatorActionTypes = createActionTypes(
  "creatorProfile/unfollow",
);

export const setCreatorSubscriptionActionTypes =
  "creatorProfile/subscription/set";

export const setCreatorSubscriptionPortionActionTypes =
  "creatorProfile/subscription/setPortion";

export const hideReportActionTypes = createActionTypes(
  "creatorProfile/hideReport",
);

export const setConversationActionType = "creatorProfile/setConversation";
